import React from 'react';
import './homepage.styles.css';
// import AnimatedBackground from '../../components/animatedbackground/background.animation.component';

function HomePage (){
    return(
      <div>
          <h1 className='homeTitle'>
            العنود
          </h1>
          
          <div className='list'>
              <div className='title1'> 
                  <h3>لله در أنـاس أينمـا ذكــروا</h3>
                  <h3>تطيب سيرتهم حتى وإن غابــوا</h3>
              </div>
              <div className='title2'> 
                  <h3>ولرب مكرمة جمعت شمائلهــــم</h3>
                  <h3>صارت لنا غيثا يسري وينســاب</h3>
              </div>
              <div className='title3'>
                <h3>لا يعرفــون الشر مقـدار أنملــة</h3>
                <h3>هم دائمــا أبدا للخير أسبـــاب</h3>
              </div>
              <div className='title4'>
                <h3>في قلب من يلقو تلقـى محبتهـــم</h3>
                <h3>وهم لكل الخلـــق صحب وأحبــــاب</h3>
              </div>
              <div className='title5'>
                <h3>أولئــك الأخيار قد طاب منزلهـــم</h3>
                <h3>ميراثهـــم بــر خلــــــق وآداب</h3>
              </div>
              
              <div className='title5'>
              
                <h3>شعر علاء زايد</h3>
              </div>
              
              {/* <AnimatedBackground/> */}
          </div>
          <h4>علوم التفسير والحديث والتاريخ</h4>
          <h3> إهداء إلي المعلمة عنود غريب المطيري - نسأل الله لها الرحمه</h3>
          <br/><br/><br/><br/>
        </div>
    );
        
  }
  
  export default HomePage;